import { styled } from "@mui/material";

export const Container = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  overflow: "hidden",
}));
